export const fontFamily = "Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol' !default;";
export const fontComic = "DigitalStrip Bold, Roboto, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'";
export const colorBlack54 = "rgba(0, 0, 0, 0.45);";
export const colorPrimary = "rgba(0, 0, 0, 0.85)";

export const clBlack = "#000000";
export const cyan7 = "#08979c";
export const orange7 = "#D46B08";
export const backgroundEven = "#FAFAFA";
